export const MAX_CURRENCY_AMOUNT = 100000000


export const getYearsSince = (year: number): number[] => {
    const currentYear = new Date().getFullYear();
    const years: number[] = [];

    for (let y = currentYear; y >= year; y--) {
        years.push(y);
    }

    return years;
};


export const formatNumber = (value: unknown, decimals = 2) => {
    if (value === null || value === undefined) return "-"
    const num = Number(value)
    if (Number.isNaN(num)) return "-"
    return num.toFixed(decimals)
}


export const formatCurrency = (
    value: unknown,
    currency: string = "CAD",
    minimumFractionDigits = 2
) => {
    if (value === null || value === undefined) return "-"
    const num = Number(value)
    if (Number.isNaN(num)) return "-"

    return new Intl.NumberFormat("en-CA", {
        style: "currency",
        currency,
        minimumFractionDigits
    }).format(num)
}


export const formatDateTimeAmPm = (value: string | Date | null | undefined) => {
    if (!value) return "-"

    const date = value instanceof Date ? value : new Date(value)
    if (isNaN(date.getTime())) return "-"

    return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "short",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        hour12: true
    }).format(date)
}


export function getMonthYearLabel(date: Date): string {
    return date.toLocaleString("en-CA", {
        month: "short",
        year: "numeric"
    })
}

// "Feb 25th, 2026" (date only; reads the date part of ISO strings so time zones don't shift the day)
export const formatDate = (value: string | Date | null | undefined): string => {
    if (!value) return "-"
    const date = typeof value === "string"
        ? new Date(`${value.slice(0, 10)}T12:00:00`)
        : value
    if (isNaN(date.getTime())) return "-"
    const day = date.getDate()
    const suffix = day % 10 === 1 && day !== 11 ? "st" : day % 10 === 2 && day !== 12 ? "nd" : day % 10 === 3 && day !== 13 ? "rd" : "th"
    return `${date.toLocaleString("en-US", { month: "short" })} ${day}${suffix}, ${date.getFullYear()}`
}
